import { render, staticRenderFns } from "./fullInfo.vue?vue&type=template&id=b813aa16&scoped=true&"
import script from "./fullInfo.vue?vue&type=script&lang=js&"
export * from "./fullInfo.vue?vue&type=script&lang=js&"
import style0 from "./fullInfo.vue?vue&type=style&index=0&id=b813aa16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b813aa16",
  null
  
)

export default component.exports